export interface LineageDefinition {
  id: string;
  label: string;
  family: "chromatic" | "metallic";
  element: string;
  damage: string;
  accent: string;
  accentSoft: string;
  terrains: string[];
  dispositions: string[];
  breathShape: "cone" | "line";
  challenge: [number, number, number, number];
}

export const LINEAGES: LineageDefinition[] = [
  {
    id: "red",
    label: "Red Dragon",
    family: "chromatic",
    element: "fire",
    damage: "fire",
    accent: "#e8542c",
    accentSoft: "#ffa26b",
    terrains: ["Volcanic", "Mountain", "Ruins"],
    dispositions: ["Proud", "Cruel", "Strategic"],
    breathShape: "cone",
    challenge: [4, 10, 17, 24]
  },
  {
    id: "blue",
    label: "Blue Dragon",
    family: "chromatic",
    element: "lightning",
    damage: "lightning",
    accent: "#4d84d4",
    accentSoft: "#9bc5ff",
    terrains: ["Desert", "Coast", "Ruins"],
    dispositions: ["Patient", "Vain", "Methodical"],
    breathShape: "line",
    challenge: [3, 9, 16, 23]
  },
  {
    id: "green",
    label: "Green Dragon",
    family: "chromatic",
    element: "poison",
    damage: "poison",
    accent: "#63a83e",
    accentSoft: "#a8d97c",
    terrains: ["Forest", "Swamp", "Ruins"],
    dispositions: ["Manipulative", "Cultured", "Possessive"],
    breathShape: "cone",
    challenge: [2, 8, 15, 22]
  },
  {
    id: "black",
    label: "Black Dragon",
    family: "chromatic",
    element: "acid",
    damage: "acid",
    accent: "#8f9a4e",
    accentSoft: "#cdd68a",
    terrains: ["Swamp", "Ruins", "Coast"],
    dispositions: ["Patient", "Sadistic", "Secretive"],
    breathShape: "line",
    challenge: [2, 7, 14, 21]
  },
  {
    id: "white",
    label: "White Dragon",
    family: "chromatic",
    element: "frost",
    damage: "cold",
    accent: "#a9d8ea",
    accentSoft: "#e2f7ff",
    terrains: ["Tundra", "Mountain", "Coast"],
    dispositions: ["Relentless", "Instinctive", "Territorial"],
    breathShape: "cone",
    challenge: [2, 6, 13, 20]
  },
  {
    id: "gold",
    label: "Gold Dragon",
    family: "metallic",
    element: "radiant fire",
    damage: "fire",
    accent: "#e3b34f",
    accentSoft: "#ffe09a",
    terrains: ["Mountain", "Forest", "Ruins"],
    dispositions: ["Judicious", "Patient", "Exacting"],
    breathShape: "cone",
    challenge: [3, 10, 17, 24]
  },
  {
    id: "silver",
    label: "Silver Dragon",
    family: "metallic",
    element: "frost",
    damage: "cold",
    accent: "#b9c8dc",
    accentSoft: "#eff7ff",
    terrains: ["Mountain", "Tundra", "City"],
    dispositions: ["Curious", "Protective", "Nostalgic"],
    breathShape: "cone",
    challenge: [2, 9, 16, 23]
  },
  {
    id: "bronze",
    label: "Bronze Dragon",
    family: "metallic",
    element: "storm",
    damage: "lightning",
    accent: "#c08b57",
    accentSoft: "#ecc08a",
    terrains: ["Coast", "Sea", "Ruins"],
    dispositions: ["Observant", "Honorable", "Restless"],
    breathShape: "line",
    challenge: [2, 8, 15, 22]
  },
  {
    id: "brass",
    label: "Brass Dragon",
    family: "metallic",
    element: "desert fire",
    damage: "fire",
    accent: "#d4a95e",
    accentSoft: "#f4cf91",
    terrains: ["Desert", "Mountain", "Ruins"],
    dispositions: ["Talkative", "Inquisitive", "Tenacious"],
    breathShape: "line",
    challenge: [1, 6, 13, 20]
  },
  {
    id: "copper",
    label: "Copper Dragon",
    family: "metallic",
    element: "acid",
    damage: "acid",
    accent: "#cd7a4a",
    accentSoft: "#f0a878",
    terrains: ["Mountain", "Canyon", "Forest"],
    dispositions: ["Witty", "Clever", "Mercurial"],
    breathShape: "line",
    challenge: [1, 7, 14, 21]
  }
];

export const AGE_CLASSES = ["wyrmling", "young", "adult", "ancient"] as const;
export const TERRAINS = [
  "Volcanic",
  "Mountain",
  "Swamp",
  "Sea",
  "Forest",
  "Ruins",
  "Desert",
  "Coast",
  "Tundra",
  "Canyon",
  "City"
] as const;

export function getLineage(id: string): LineageDefinition {
  return LINEAGES.find((lineage) => lineage.id === id) ?? LINEAGES[0];
}
